import {
  compose, withHandlers, withPropsOnChange, mapProps,
} from 'recompose'
import { Pagination as PaginationBC } from '@infotech/base-components'

const Pagination = compose(
  withHandlers({
    setOffset: (props) => (offset) => {
      const { limit, onPageClick } = props
      const page = offset / limit
      onPageClick(page + 1)
    },
  }),
  withPropsOnChange([`currentPage`, `limit`], ({
    currentPage,
    limit,
  }) => ({
    query: {
      limit,
      offset: (currentPage - 1) * limit,
    },
  })),
  mapProps(({
    count,
    query,
    setOffset,
  }) => ({
    total: count,
    query,
    setOffset,
  })),
)(PaginationBC)

export default Pagination
